import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/Accordion';
import { AudioDetailDto } from '@/service/interface';
import React from 'react';

type Props = {
  selectedSongDetail: AudioDetailDto;
};

export const StyleFilterConfigs: React.FC<Props> = ({ selectedSongDetail }) => {
  return (
    <div className="items-center">
      <Accordion type="single" collapsible>
        <AccordionItem value="item-1">
          <AccordionTrigger className="px-[16px] pr-[8px] h-[48px] border-t border-jen-border">
            <div className=" text-jen-size-heading-07 text-jen-content-tertiary">STYLE FILTER CONFIGS</div>
          </AccordionTrigger>
          <AccordionContent className="mb-4 px-[16px] pr-[8px] mt-[20px] font-pressura-mono text-[12px] leading-[16px] text-jen-content-secondary">
            <PropertiesItem label="SF STEPS" value={selectedSongDetail?.metadata?.stylefilterStep} />
            <PropertiesItem label="FILTER TI" value={selectedSongDetail?.metadata?.filterTI} />
            <PropertiesItem label="FILTER WEIGHT" value={selectedSongDetail?.metadata?.filterWeight} />
            <PropertiesItem label="MIN WEIGHT" value={selectedSongDetail?.metadata?.min_weight} />
            <PropertiesItem label="MAX WEIGHT" value={selectedSongDetail?.metadata?.max_weight} />
            <PropertiesItem label="SIMILAR SENSITIVE" value={selectedSongDetail?.metadata?.similar_sensitive} />
            <PropertiesItem
              label="SIMILAR SCORE"
              value={selectedSongDetail?.metadata?.similarity_score ? selectedSongDetail.metadata.similarity_score.toFixed(2) : ''}
            />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

const PropertiesItem = ({ label, value }: { label: string; value?: string | number }) => {
  return (
    <div className=" flex justify-between mt-jen-spacing-4">
      <div>{label}</div>
      <div>{value ?? ''}</div>
    </div>
  );
};
